import {
    CREATE_PRODUCT,
    CREATE_PRODUCT_FAILURE,
    CREATE_PRODUCT_SUCCESS,

    CREATE_PRODUCT_LOGO,
    CREATE_PRODUCT_LOGO_FAILURE,
    CREATE_PRODUCT_LOGO_SUCCESS,
} from 'store/actions/types';

export const createProduct = (payload) => {
    return {
        type: CREATE_PRODUCT,
        payload: payload,
    };
};

export const createProductFailure = (error) => {
    return {
        type: CREATE_PRODUCT_FAILURE,
        error: error,
    };
};

export const createProductSuccess = (response) => {
    return {
        type: CREATE_PRODUCT_SUCCESS,
        id: response.id,
        response: response,
    };
};

export const createProductLogo = (payload) => {
    return {
        type: CREATE_PRODUCT_LOGO,
        payload: payload,
    };
};

export const createProductLogoFailure = (error) => {
    return {
        type: CREATE_PRODUCT_LOGO_FAILURE,
        error: error,
    };
};

export const createProductLogoSuccess = (id, response) => {
    return {
        type: CREATE_PRODUCT_LOGO_SUCCESS,
        productId: id,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/createProducts.js